import InnerComponent from '@Components/Purchase/GoodsReceiving/GoodsReceivingHome';
import orgContainer from '@Components/AppContainer';

const OrgCreateProduct = () => ((orgContainer(InnerComponent)));
export default OrgCreateProduct;
